import { useEffect, useState } from 'react'

/** Resolves when the image URL has loaded (or failed — avoids infinite spinner). */
export function usePreloadedImage(src: string): boolean {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!src) {
      setReady(true)
      return
    }

    let cancelled = false
    const img = new window.Image()
    const done = () => {
      if (!cancelled) setReady(true)
    }
    img.onload = done
    img.onerror = done
    img.src = src

    return () => {
      cancelled = true
    }
  }, [src])

  return ready
}
